import React, { useState, useEffect,useCallback} from "react";
import { HeadingFour, MyDiv } from "../Common/Components";
import { Row, Col, Card } from "react-bootstrap";
import { TextField } from "@mui/material";
import swal from "sweetalert2";
import { getRequest,patchRequest  } from "../Common/api/apiService";

function EstimateForm({ handleClose, projectID, editMode, deptData }) {
  // console.log('deptName', deptData)
  const [data, setData] = useState({
    department: "",
    estimation_hours: "",
    planned_start_date: null,
    actual_start_date: null,
    planned_end_date: null,
    actual_end_date: null,
    notes: "",
  });

  const [, setresourceData] = useState([]);


  
const loadResource = useCallback(async () => {
  try {
    const response = await getRequest(`fetchProjectResource`);
    setresourceData(response.data);
  } catch (error) {
    console.error("Resource Fetch Error:", error);
    swal.fire({
      text: error.response?.data || "Failed to fetch project resources.",
      icon: "error",
    });
  }
}, []);


  useEffect(() => {
    loadResource();

    if (editMode) {
      setData(deptData);
    }
  }, [setData,setresourceData,loadResource,deptData,editMode]);


  function handle(e) {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  }
  const handleChangeWhiteSpace = e => {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  };



  const submit = useCallback(
  async (e) => {
    e.preventDefault();

    try {
      const response = await patchRequest(
        `update-project-department-details/${projectID}`,
        data
      );

      if (response?.status === 200) {
        swal.fire({
          text: "Successfully Saved",
          icon: "success",
        });
        handleClose();
      }
    } catch (error) {
      console.error("Submit Error:", error);
      swal.fire({
        text: error.response?.data || "Failed to save data.",
        icon: "error",
      });
    }
  },
  [data, projectID, handleClose]
);


  return (
    <MyDiv className="DrawerRight">
      <MyDiv className="grid-margin general-form stretch-card">
        <Card md={12}>
          <Card.Header>
            <HeadingFour className="card-title">{/* Manage {data.estimation_Department} Estimation */}</HeadingFour>
          </Card.Header>
          <Card.Body>
            <MyDiv className="DrawerForm">
              <form onSubmit={e => submit(e)}>
                <Row className="DrawerFormField">
                  <Col md={12}>
                    <TextField
                      disabled
                      required
                      id="department"
                      label="Department Name"
                      value={data.department}
                      variant="standard"
                      onChange={e => handleChangeWhiteSpace(e)}
                    />
                  </Col>
                  <Col md={12}>
                    <TextField
                      required
                      id="estimation_hours"
                      label="Estimation Hours"
                      value={data.estimation_hours}
                      variant="standard"
                      onChange={e => handleChangeWhiteSpace(e)}
                    />
                  </Col>
                  {data.department !== "ProjectManagement" ? (
                    <>
                      <Col md={12}>
                        <TextField
                          id="planned_start_date"
                          label="Planned Start Date and Time"
                          type="datetime-local"
                          value={data.planned_start_date || ""}
                          sx={{ width: 220 }}
                          onChange={e => handle(e)}
                          InputLabelProps={{ shrink: true }}
                          variant="standard"
                        />
                      </Col>
                      <Col md={12}>
                        <TextField
                          id="planned_end_date"
                          label="Planned End Date and Time"
                          inputProps={{}}
                          type="datetime-local"
                          value={data.planned_end_date || ""}
                          sx={{ width: 220 }}
                          onChange={e => handle(e)}
                          InputLabelProps={{ shrink: true }}
                          variant="standard"
                        />
                      </Col>
                      <Col md={12}>
                        <TextField
                          id="actual_start_date"
                          label="Actual Start Date and Time"
                          type="datetime-local"
                          value={data.actual_start_date || ""}
                          sx={{ width: 220 }}
                          onChange={e => handle(e)}
                          InputLabelProps={{ shrink: true }}
                          variant="standard"
                        />
                      </Col>
                      <Col md={12}>
                        <TextField
                          id="actual_end_date"
                          label="Actual End Date and Time"
                          inputProps={{}}
                          type="datetime-local"
                          value={data.actual_end_date || ""}
                          sx={{ width: 220 }}
                          onChange={e => handle(e)}
                          InputLabelProps={{ shrink: true }}
                          variant="standard"
                        />
                      </Col>
                    </>
                  ) : null}
                  <Col md={12}>
                    <TextField
                      id="notes"
                      multiline
                      rows={4}
                      label="Notes"
                      value={data.notes}
                      variant="standard"
                      onChange={e => handleChangeWhiteSpace(e)}
                    />
                  </Col>
                  <Col md={12} className="text-end">
                    <button className="FormBtn">Submit</button>
                  </Col>
                </Row>
              </form>
            </MyDiv>
          </Card.Body>
        </Card>
      </MyDiv>
    </MyDiv>
  );
}
export default EstimateForm;
